import getCaps, { defaultCap } from '@anm/data/streaming/destinationsCaps';
import { useEffect, useState } from 'react';

import { DestinationWithStreamMeta } from '../../StreamItem';

type HookProps = {
  name: string;
  destinationsList: DestinationWithStreamMeta[];
  selectedDestinationIds: string[];
  toStreamDetails(): void;
};

const useTitleMaxLength = ({ name, destinationsList, selectedDestinationIds, toStreamDetails }: HookProps) => {
  const [titleMaxLength, setTitleMaxLength] = useState(defaultCap.titleMaxLength);

  useEffect(() => {
    const newMaxLength = selectedDestinationIds.reduce((acc, id) => {
      const destination = destinationsList.find(d => d.id === id);

      if (!destination) return acc;

      return Math.min(acc, getCaps(destination.network, destination.kind).titleMaxLength);
    }, defaultCap.titleMaxLength);

    setTitleMaxLength(newMaxLength);

    if (name.length > newMaxLength) toStreamDetails();
  }, [selectedDestinationIds.length]);

  return titleMaxLength;
};

export default useTitleMaxLength;
